import React from 'react';
import { ArrowRight, CheckCircle2, Award, Users } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = ({ data, onApplyClick }) => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${data.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="hero-overlay absolute inset-0"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full container-padding section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            {/* Badges */}
            <div className="flex flex-wrap gap-3 mb-6 animate-fade-in">
              <span className="badge-scholarship inline-flex items-center gap-2">
                <Award className="w-4 h-4" />
                100% Scholarship Available
              </span>
              <span className="badge-seats inline-flex items-center gap-2">
                <Users className="w-4 h-4" />
                Only 60 Seats
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in-up stagger-1">
              {data.title}
            </h1>

            {/* Subtitle */}
            <p className="text-xl md:text-2xl text-gray-100 mb-8 leading-relaxed animate-fade-in-up stagger-2">
              {data.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8 animate-fade-in-up stagger-3">
              <Button
                size="lg"
                className="btn-primary-purple btn-transition text-lg px-8 py-6 focus-ring"
                onClick={onApplyClick}
              >
                {data.ctaText}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="btn-outline-green btn-transition text-lg px-8 py-6 border-white text-white hover:bg-white hover:text-gray-900"
                onClick={() => document.getElementById('program-details')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Learn More
              </Button>
            </div>

            {/* Subtext */}
            <p className="text-gray-200 text-sm flex items-center gap-2 animate-fade-in-up stagger-4">
              <CheckCircle2 className="w-5 h-5 text-green-400" />
              {data.ctaSubtext}
            </p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};
